// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3c42d035","80":"212c9d54","310":"b690eccf","325":"3d245faf","529":"a00e7aca","623":"3907a67a","699":"2814160c","715":"4fe1d5ec","785":"b90738d5","892":"a888c1d3"}[chunkId] + ".chunk.js";
};